import { sum, get } from 'lodash';

export const leveling = {
    "5": {
        "lvl": 100,
        "self:4": 2,
        "self:5": 1, // get 5* or build from 4+3*
        "4": 6,
        "3": 4,
        "stone": 1800,
        "spirit": 2600000,
        "gold": 5600000,
    },
    "6": {
        "lvl": 140,
        "self:5": 1,
        "5": 4,
        "stone": 2000,
        "spirit": 12000000,
        "gold": 14000000,
    },
    "7": {
        "lvl": 160,
        "self:5": 0,
        "5": 4,
        "stone": 2000,
        "spirit": 9100000,
        "gold": 9700000,
    },
    "8": {
        "lvl": 180,
        "self:5": 0,
        "5": 3,
        "6": 1,
        "stone": 3000,
        "spirit": 10400000,
        "gold": 10600000,
    },
    "9": {
        "lvl": 200,
        "self:5": 1,
        "5": 2,
        "6": 1,
        "stone": 4000,
        "spirit": 12400000,
        "gold": 11800000,
    },
    "10": {
        "lvl": 250,
        "self:5": 2,
        "6": 1,
        "9": 1,
        "stone": 10000,
        "spirit": 77000000,
        "gold": 39000000,
    },
    "E1": {
        "lvl": 260,
        "self:5": 1,
        "9": 1,
        "10": 0,
        "stone": 10000,
        "spirit": 32000000,
        "gold": 11100000,
    },
    "E2": {
        "lvl": 270,
        "self:5": 1,
        "9": 1,
        "10": 0,
        "stone": 10000,
        "spirit": 41000000,
        "gold": 14000000,
    },
    "E3": {
        "lvl": 290,
        "self:5": 0,
        "9": 0,
        "10": 1,
        "stone": 15000,
        "spirit": 104000000,
        "gold": 35000000,
    },
    "E4": {
        "lvl": 310,
        "self:5": 1,
        "9": 0,
        "10": 1,
        "stone": 15000,
        "spirit": 137000000,
        "gold": 46000000,
    },
    "E5": {
        "lvl": 330,
        "self:5": 1,
        "9": 0,
        "10": 1,
        "stone": 20000,
        "spirit": 209000000,
        "gold": 70000000,
        "stellar": 0,
    },
    "V1": {
        "lvl": 330,
        "10": 1,
        "stellar": 138630,
    },
    "V2": {
        "lvl": 330,
        "10": 1,
        "stellar": 587610,
    },
    "V3": {
        "lvl": 330,
        "10": 1,
        "stellar": 1458390,
    },
    "V4": {
        "lvl": 330,
        "10": 1,
        "stellar": 2750070,
    },
    "+5": {
        "lvl": 335,
        "spirit": 64300000,
        "gold": 21600000,
    },
    "+10": {
        "lvl": 340,
        "spirit": 69100000,
        "gold": 23200000,
    },
    "+15": {
        "lvl": 345,
        "spirit": 73900000,
        "gold": 24800000,
    },
    "+20": {
        "lvl": 350,
        "spirit": 78700000,
        "gold": 26500000,
    },
}

export const levelup = [
    {
        "lvl": 100,
        "stone": 1800,
        "spirit": 2600000,
        "gold": 5600000,
    },
    {
        "lvl": 140,
        "stone": 2000,
        "spirit": 12000000,
        "gold": 14000000,
    },
    {
        "lvl": 160,
        "stone": 2000,
        "spirit": 9100000,
        "gold": 9700000,
    },
    {
        "lvl": 180,
        "stone": 3000,
        "spirit": 10400000,
        "gold": 10600000,
    },
    {
        "lvl": 200,
        "stone": 4000,
        "spirit": 12400000,
        "gold": 11800000,
    },
    {
        "lvl": 250,
        "stone": 10000,
        "spirit": 77000000,
        "gold": 39000000,
    },
    {
        "lvl": 260,
        "stone": 10000,
        "spirit": 32000000,
        "gold": 11100000,
    },
    {
        "lvl": 270,
        "stone": 10000,
        "spirit": 41000000,
        "gold": 14000000,
    },
    {
        "lvl": 290,
        "stone": 15000,
        "spirit": 104000000,
        "gold": 35000000,
    },
    {
        "lvl": 310,
        "stone": 15000,
        "spirit": 137000000,
        "gold": 46000000,
    },
    {
        "lvl": 330,
        "stone": 20000,
        "spirit": 209000000,
        "gold": 70000000,
    },
    {
        "lvl": 350,
        "stone": 0,
        "spirit": 286000000,
        "gold": 96100000,
    },
    {
        "lvl": 360,
        "stone": 0,
        "spirit": 201000000,
        "gold": 70000000,
    },
    {
        "lvl": 370,
        "stone": 0,
        "spirit": 266000000,
        "gold": 95000000,
    },
    {
        "lvl": 380,
        "stone": 0,
        "spirit": 352000000,
        "gold": 133000000,
    },
    {
        "lvl": 390,
        "stone": 0,
        "spirit": 465000000,
        "gold": 185000000,
    },
    {
        "lvl": 400,
        "stone": 0,
        "spirit": 616000000,
        "gold": 253000000,
    },
    {
        "lvl": 'X-20',
        "stone": 10000,
        "spirit": 1321000000,
        "gold": 548000000,
        "x": 500
    },
    {
        "lvl": 'X-40',
        "stone": 10000,
        "spirit": 1348000000,
        "gold": 559000000,
        "x": 600
    },
    {
        "lvl": 'X-60',
        "stone": 10000,
        "spirit": 1375000000,
        "gold": 571000000,
        "x": 700
    },
    {
        "lvl": 'X-80',
        "stone": 10000,
        "spirit": 1403000000,
        "gold": 582000000,
        "x": 800
    },
    {
        "lvl": 'X-100',
        "stone": 10000,
        "spirit": 1431000000,
        "gold": 593000000,
        "x": 900
    },
    
]

export const imprintsFull = {
    "V1": {
        "HP": [600,626,652,678,704,730,782,834,886,938,990,1068,1146,1224,1302,1380,1484,1588,1692,1796,1900,2030,2160,2290,2420,2550,2706,2862,3018,3174],
        "Attack": [600,626,652,678,704,730,782,834,886,938,990,1068,1146,1224,1302,1380,1484,1588,1692,1796,1900,2030,2160,2290,2420,2550,2706,2862,3018,3174],
        "Attack HP": [1878,2112,2502,2996,3672,4452,5388,6480,7676,9054],
    },
    "V2": {
        "HP": [3330,3512,3694,3876,4058,4240,4448,4656,4864,5072,5280,5514,5748,5982,6216,6450,6710,6970,7230,7490,7750,8036,8322,8608,8894,9180,9492,9804,10116,10428],
        "Attack": [3330,3512,3694,3876,4058,4240,4448,4656,4864,5072,5280,5514,5748,5982,6216,6450,6710,6970,7230,7490,7750,8036,8322,8608,8894,9180,9492,9804,10116,10428],
        "Attack HP": [10536,12174,13968,15866,17946,20130,22470,24966,27566,30348],
    },
    "V3": {
        "HP": [10740,11078,11416,11754,12092,12430,12794,13158,13522,13886,14250,14640,15030,15420,15810,16200,16616,17032,17448,17864,18280,18722,19164,19606,20048,20490,20958,21426,21894,22362],
        "Attack": [10740,11078,11416,11754,12092,12430,12794,13158,13522,13886,14250,14640,15030,15420,15810,16200,16616,17032,17448,17864,18280,18722,19164,19606,20048,20490,20958,21426,21894,22362],
        "Attack HP": [33234,36276,39474,42776,46260,49848,53592,57492,61496,65682],
    },
    "V4": {
        "HP": [22830,23324,23818,24312,24806,25300,25820,26340,26860,27380,27900,28446,28992,29538,30084,30630,31202,31774,32346,32918,33490,34088,34686,35284,35882,36480,37104,37728,38352,38976],
        "Attack": [22830,23324,23818,24312,24806,25300,25820,26340,26860,27380,27900,28446,28992,29538,30084,30630,31202,31774,32346,32918,33490,34088,34686,35284,35882,36480,37104,37728,38352,38976],
        "Speed": [69972,74418,79020,83726,88614,93606,98754,104058,109466,115056],
    },
}

export const imprintsNodes = {
    'V1': {
        "HP":           sum(imprintsFull.V1.HP),
        "Attack":       sum(imprintsFull.V1.Attack),
        "Attack HP":    sum(imprintsFull.V1['Attack HP']),
    },
    'V2': {
        "HP":           sum(imprintsFull.V2.HP),
        "Attack":       sum(imprintsFull.V2.Attack),
        "Attack HP":    sum(imprintsFull.V2['Attack HP']),
    },
    'V3': {
        "HP":           sum(imprintsFull.V3.HP),
        "Attack":       sum(imprintsFull.V3.Attack),
        "Attack HP":    sum(imprintsFull.V3['Attack HP']),
    },
    'V4': {
        "HP":           sum(imprintsFull.V4.HP),
        "Attack":       sum(imprintsFull.V4.Attack),
        "Speed":        sum(imprintsFull.V4['Speed']),
    },
}

export const imprintsTotal = {
    'V1': sum(Object.values(imprintsNodes.V1)),
    'V2': sum(Object.values(imprintsNodes.V2)),
    'V3': sum(Object.values(imprintsNodes.V3)),
    'V4': sum(Object.values(imprintsNodes.V4)),
}
const imprintRankMap  = {'E5': 'V1', 'V1': 'V2', 'V2': 'V3', 'V3': 'V4'};

export const nodesCost = (rank: string /*'E5'|'V1'|'V2'|'V3'*/, nodes: number[]): number => {
    if (rank === 'V4'){
        return 0
    }
        
    let imprintRank = get(imprintRankMap, rank) as keyof typeof imprintsTotal;
    return 0
           + sum(get(imprintsFull[imprintRank], 'HP').slice(0, nodes[0]))
           + sum(get(imprintsFull[imprintRank], 'Attack').slice(0, nodes[1]))
           + (imprintRank === 'V4'
                ? sum(get(imprintsFull[imprintRank], 'Speed').slice(0, nodes[2])) 
                : sum(get(imprintsFull[imprintRank], 'Attack HP').slice(0, nodes[2]))
           )
}

export const imprintsCost = (rank: string /*'E5'|'V1'|'V2'|'V3'*/, nodes: number[]): number => {
    if (rank === 'V4'){
        return imprintsTotal.V4
    }
        
    let imprintRank = get(imprintRankMap, rank) as keyof typeof imprintsTotal;
    return get(imprintsTotal, rank, 0)
           + sum(get(imprintsFull[imprintRank], 'HP').slice(0, nodes[0]))
           + sum(get(imprintsFull[imprintRank], 'Attack').slice(0, nodes[1]))
           + (imprintRank === 'V4'
                ? sum(get(imprintsFull[imprintRank], 'Speed').slice(0, nodes[2])) 
                : sum(get(imprintsFull[imprintRank], 'Attack HP').slice(0, nodes[2]))
           )
}

export const tree = [
    {
        dsc: 'V4',
        lvl: 0,
        stellar: 4935000,
        esence: 0,
        unlock: '',
    },
    {
        dsc: 'T1',
        lvl: 20,
        stellar: 307350,
        esence: 31020,
        unlock: 'Core',
    },
    {
        dsc: 'T2',
        lvl: 40,
        stellar: 637350,
        esence: 69820,
        unlock: 'A',
    },
    {
        dsc: 'T3',
        lvl: 60,
        stellar: 1127350,
        esence: 132620,
        unlock: 'P1',
    },
    {
        dsc: 'T4',
        lvl: 80,
        stellar: 1777350,
        esence: 219420,
        unlock: 'P2',
    },
    {
        dsc: 'T5',
        lvl: 100,
        stellar: 2587350,
        esence: 330220,
        unlock: 'P3',
    },
    {
        dsc: 'max',
        lvl: 120,
        stellar: 3557350,
        esence: 465020,
        unlock: 'Destiny Transition',
    },
]

export const treeLevels = {
    esence: [1000,1040,1083,1129,1178,1230,1285,1343,1404,1468,1535,1605,1678,1754,1833,1915,2000,2088,2179,2273,2370,2470,2573,2679,2788,2900,3015,3133,3254,3378,3505,3635,3768,3904,4043,4185,4330,4478,4629,4783,4940,5100,5263,5429,5598,5770,5945,6123,6304,6488,6675,6865,7058,7254,7453,7655,7860,8068,8279,8493,8710,8930,9153,9379,9608,9840,10075,10313,10554,10798,11045,11295,11548,11804,12063,12325,12590,12858,13129,13403,13680,13960,14243,14529,14818,15110,15405,15703,16004,16308,16615,16925,17238,17554,17873,18195,18520,18848,19179,19513,19850,20190,20533,20879,21228,21580,21935,22293,22654,23018,23385,23755,24128,24504,24883,25265,25650,26038,26429,26823],
    stellar: [10000,10445,10910,11395,11900,12425,12970,13535,14120,14725,15350,15995,16660,17345,18050,18775,19520,20285,21070,21875,22700,23545,24410,25295,26200,27125,28070,29035,30020,31025,32050,33095,34160,35245,36350,37475,38620,39785,40970,42175,43400,44645,45910,47195,48500,49825,51170,52535,53920,55325,56750,58195,59660,61145,62650,64175,65720,67285,68870,70475,72100,73745,75410,77095,78800,80525,82270,84035,85820,87625,89450,91295,93160,95045,96950,98875,100820,102785,104770,106775,108800,110845,112910,114995,117100,119225,121370,123535,125720,127925,130150,132395,134660,136945,139250,141575,143920,146285,148670,151075,153500,155945,158410,160895,163400,165925,168470,171035,173620,176225,178850,181495,184160,186845,189550,192275,195020,197785,200570,203375],
}

export const treeCost = (lvl: number): {esence: number, stellar: number} => {
    return {
        esence: sum(treeLevels.esence.slice(0, lvl)),
        stellar: sum(treeLevels.stellar.slice(0, lvl))
    }
}

export const destiny = [
    {
        dsc: '',
        name: 'T120',
        aurora: 0,
        cot: 5000000,
        spiritvein: 0,
        stellar: 14929100,
        spiritvein_lvl: [],
        stellar_lvl: [],
    },
    {
        dsc: 'D1',
        name: 'Origin',
        aurora: 5,
        cot: 420000,
        spiritvein: 197236,
        stellar: 821540,
        spiritvein_lvl: [0, 1600,1608,1616,1624,1632,1640,1648,1656,1664,1672,1680,1688,1696,1704,1712,1720,1728,1736,1744,1752,1760,1768,1776,1784,1792,1800,1808,1816,1824,1832,1840,1848,1856,1864,1872,1880,1888,1896,1904,1912,1920,1928,1936,1944,1952,1960,1968,1976,1984,1992,2000,2008,2016,2024,2032,2040,2048,2056,2064,2072,2080,2088,2096,2104,2112,2120,2128,2136,2144,2152,2160,2168,2176,2184,2192,2200,2208,2216,2224,2232,2240,2248,2256,2264,2272,2280,2288,2296,2304,2312,2320,2328,2337,2346,2355,2364,2373,2382,2391],
        stellar_lvl: [0, 6500,6600,6720,6760,6800,6830,6870,6900,6930,6970,7000,7030,7070,7100,7130,7170,7200,7230,7270,7300,7330,7370,7400,7430,7470,7500,7530,7570,7600,7630,7670,7700,7730,7770,7800,7830,7870,7900,7930,7970,8000,8030,8070,8100,8130,8170,8200,8230,8270,8300,8330,8370,8400,8430,8470,8500,8530,8570,8600,8630,8670,8700,8730,8770,8800,8830,8870,8900,8930,8970,9000,9030,9070,9100,9130,9170,9200,9230,9270,9300,9330,9370,9400,9430,9470,9500,9530,9570,9600,9630,9670,9700,9740,9780,9810,9850,9890,9930,9960],
    },
    {
        dsc: 'D2',
        name: 'Surge',
        aurora: 7,
        cot: 590000,
        spiritvein: 277200,
        stellar: 1155000,
        spiritvein_lvl: [0, 2408,2416,2424,2432,2440,2448,2456,2464,2472,2480,2488,2496,2504,2512,2520,2528,2536,2544,2552,2560,2568,2576,2584,2592,2600,2608,2616,2624,2632,2640,2648,2656,2664,2672,2680,2688,2696,2704,2712,2720,2728,2736,2744,2752,2760,2768,2776,2784,2792,2800,2808,2816,2824,2832,2840,2848,2856,2864,2872,2880,2888,2896,2904,2912,2920,2928,2936,2944,2952,2960,2968,2976,2984,2992,3000,3008,3016,3024,3032,3040,3048,3056,3064,3072,3080,3088,3096,3104,3112,3120,3128,3136,3144,3152,3160,3168,3176,3184,3192],
        stellar_lvl: [0, 10030,10070,10100,10130,10170,10200,10230,10270,10300,10330,10370,10400,10430,10470,10500,10530,10570,10600,10630,10670,10700,10730,10770,10800,10830,10870,10900,10930,10970,11000,11030,11070,11100,11130,11170,11200,11230,11270,11300,11330,11370,11400,11430,11470,11500,11530,11570,11600,11630,11670,11700,11730,11770,11800,11830,11870,11900,11930,11970,12000,12030,12070,12100,12130,12170,12200,12230,12270,12300,12330,12370,12400,12430,12470,12500,12530,12570,12600,12630,12670,12700,12730,12770,12800,12830,12870,12900,12930,12970,13000,13030,13070,13100,13130,13170,13200,13230,13270,1330],
    },
    {
        dsc: 'D3',
        name: 'Chaos',
        aurora: 9,
        cot: 750000,
        spiritvein: 356400,
        stellar: 1485000,
        spiritvein_lvl: [0, 3208,3216,3224,3232,3240,3248,3256,3264,3272,3280,3288,3296,3304,3312,3320,3328,3336,3344,3352,3360,3368,3376,3384,3392,3400,3408,3416,3424,3432,3440,3448,3456,3464,3472,3480,3488,3496,3504,3512,3520,3528,3536,3544,3552,3560,3568,3576,3584,3592,3600,3608,3616,3624,3632,3640,3648,3656,3664,3672,3680,3688,3696,3704,3712,3720,3728,3736,3744,3752,3760,3768,3776,3784,3792,3800,3808,3816,3824,3832,3840,3848,3856,3864,3872,3880,3888,3896,3904,3912,3920,3928,3936,3944,3952,3960,3968,3976,3984,3992],
        stellar_lvl: [0, 13370,13400,13430,13470,13500,13530,13570,13600,13630,13670,13700,13730,13770,13800,13830,13870,13900,13930,13970,14000,14030,14070,14100,14130,14170,14200,14230,14270,14300,14330,14370,14400,14430,14470,14500,14530,14570,14600,14630,14670,14700,14730,14770,14800,14830,14870,14900,14930,14970,15000,15030,15070,15100,15130,15170,15200,15230,15270,15300,15330,15370,15400,15430,15470,15500,15530,15570,15600,15630,15670,15700,15730,15770,15800,15830,15870,15900,15930,15970,16000,16030,16070,16100,16130,16170,16200,16230,16270,16300,16330,16370,16400,16430,16470,16500,16530,16570,16600,16630],
    },
    {
        dsc: 'D4',
        name: 'Core',
        aurora: 11,
        cot: 920000,
        spiritvein: 435600,
        stellar: 1815000,
        spiritvein_lvl: [0, 4008,4016,4024,4032,4040,4048,4056,4064,4072,4080,4088,4096,4104,4112,4120,4128,4136,4144,4152,4160,4168,4176,4184,4192,4200,4208,4216,4224,4232,4240,4248,4256,4264,4272,4280,4288,4296,4304,4312,4320,4328,4336,4344,4352,4360,4368,4376,4384,4392,4400,4408,4416,4424,4432,4440,4448,4456,4464,4472,4480,4488,4496,4504,4512,4520,4528,4536,4544,4552,4560,4568,4576,4584,4592,4600,4608,4616,4624,4632,4640,4648,4656,4664,4672,4680,4688,4696,4704,4712,4720,4728,4736,4744,4752,4760,4768,4776,4784,4792],
        stellar_lvl: [0, 16700,16730,16770,16800,16830,16870,16900,16930,16970,17000,17030,17070,17100,17130,17170,17200,17230,17270,17300,17330,17370,17400,17430,17470,17500,17530,17570,17600,17630,17670,17700,17730,17770,17800,17830,17870,17900,17930,17970,18000,18030,18070,18100,18130,18170,18200,18230,18270,18300,18330,18370,18400,18430,18470,18500,18530,18570,18600,18630,18670,18700,18730,18770,18800,18830,18870,18900,18930,18970,19000,19030,19070,19100,19130,19170,19200,19230,19270,19300,19330,19370,19400,19430,19470,19500,19530,19570,19600,19630,19670,19700,19730,19770,19800,19830,19870,19900,19930,19970],
    },
    {
        dsc: 'D5',
        name: 'Polystar',
        aurora: 13,
        cot: 1100000,
        spiritvein: 514800,
        stellar: 2145000,
        spiritvein_lvl: [0, 4808,4816,4824,4832,4840,4848,4856,4864,4872,4880,4888,4896,4904,4912,4920,4928,4936,4944,4952,4960,4968,4976,4984,4992,5000,5008,5016,5024,5032,5040,5048,5056,5064,5072,5080,5088,5096,5104,5112,5120,5128,5136,5144,5152,5160,5168,5176,5184,5192,5200,5208,5216,5224,5232,5240,5248,5256,5264,5272,5280,5288,5296,5304,5312,5320,5328,5336,5344,5352,5360,5368,5376,5384,5392,5400,5408,5416,5424,5432,5440,5448,5456,5464,5472,5480,5488,5496,5504,5512,5520,5528,5536,5544,5552,5560,5568,5576,5584,5592],
        stellar_lvl: [0, 20030,20070,20100,20130,20170,20200,20230,20270,20300,20330,20370,20400,20430,20470,20500,20530,20570,20600,20630,20670,20700,20730,20770,20800,20830,20870,20900,20930,20970,21000,21030,21070,21100,21130,21170,21200,21230,21270,21300,21330,21370,21400,21430,21470,21500,21530,21570,21600,21630,21670,21700,21730,21770,21800,21830,21870,21900,21930,21970,22000,22030,22070,22100,22130,22170,22200,22230,22270,22300,22330,22370,22400,22430,22470,22500,22530,22570,22600,22630,22670,22700,22730,22770,22800,22830,22870,22900,22930,22970,23000,23030,23070,23100,23130,23170,23200,23230,23270,23300],
    },
    {
        dsc: 'D6',
        name: 'Nirvana',
        aurora: 15,
        cot: 1250000,
        spiritvein: 619300,
        stellar: 2578950,
        spiritvein_lvl: [0, 5818,5826,5834,5842,5850,5858,5866,5874,5882,5890,5898,5906,5914,5922,5930,5938,5946,5954,5962,5970,5978,5986,5994,6002,6010,6018,6026,6034,6042,6050,6058,6066,6074,6082,6090,6098,6106,6114,6122,6130,6138,6146,6154,6162,6170,6178,6186,6194,6202,6210,6218,6226,6234,6242,6250,6258,6266,6274,6282,6290,6298,6306,6314,6322,6330,6338,6346,6354,6362,6370,6378,6386,6394,6402,6410,6418,6426,6434,6442,6450,6510,6530,6550,6570,6590,6610,6630,6670,6690,6710,6740,6760,6810,6860,6960,7010,7060,7110,7210],
        stellar_lvl: [0, 24190,24220,24250,24290,24320,24350,24390,24420,24450,24490,24520,24550,24590,24620,24650,24690,24720,24750,24790,24820,24850,24890,24920,24950,24990,25020,25050,25090,25120,25150,25190,25220,25250,25290,25320,25350,25390,25420,25450,25490,25520,25550,25590,25620,25650,25690,25720,25750,25790,25820,25850,25890,25920,25950,25990,26020,26050,26090,26120,26150,26190,26220,26250,26290,26320,26350,26390,26420,26450,26490,26520,26550,26590,26620,26650,26690,26720,26750,26790,26820,26850,26890,26920,26950,27190,27520,27750,27990,28120,28350,28590,28820,28950,29090,29320,29350,29390,29820,30820],
    },
]
const destinyRankMap  = {'D1': 1, 'D2': 2, 'D3': 3, 'D4': 4, 'D5': 5, 'D6': 6};

export const destinyCost = (rank: string /*'D1'|'D2'|'D3'|'D4'|'D5'|'D6'*/, lvl: number): {spiritvein: number, stellar: number} => {
    let destinyRank = get(destinyRankMap, rank);
    return {
        spiritvein: sum(destiny[destinyRank].spiritvein_lvl.slice(0, lvl)),
        stellar: sum(destiny[destinyRank].stellar_lvl.slice(0, lvl))
    }
}

export const temple = [
    {
        lvl: 1,
        bonus: 0,
        require: [0, 0, 0, 0, 0, 0],
        capacity: [3, 2, 1, 0, 0, 0],
    },
    {
        lvl: 2,
        bonus: 0,
        require: [3, 0, 0, 0, 0, 0],
        capacity: [4, 3, 2, 0, 0, 0],
    },
    {
        lvl: 3,
        bonus: 1,
        require: [2, 2, 0, 0, 0, 0],
        capacity: [5, 4, 3, 0, 0, 0],
    },
    {
        lvl: 4,
        bonus: 2,
        require: [0, 1, 2, 0, 0, 0],
        capacity: [6, 5, 4, 1, 0, 0],
    },
    {
        lvl: 5,
        bonus: 3,
        require: [2, 1, 1, 1, 0, 0],
        capacity: [7, 6, 5, 2, 0, 0],
    },
    {
        lvl: 6,
        bonus: 4,
        require: [0, 2, 2, 1, 0, 0],
        capacity: [8, 7, 6, 3, 0, 0],
    },
    {
        lvl: 7,
        bonus: 4,
        require: [1, 1, 2, 2, 0, 0],
        capacity: [9, 8, 7, 4, 1, 0],
    },
    {
        lvl: 8,
        bonus: 5,
        require: [0, 0, 2, 2, 1, 0],
        capacity: [10, 9, 8, 5, 2, 0],
    },
    {
        lvl: 9,
        bonus: 5,
        require: [0, 0, 2, 3, 1, 0],
        capacity: [11, 10, 9, 6, 3, 0],
    },
    {
        lvl: 10,
        bonus: 6,
        require: [0, 0, 3, 2, 2, 0],
        capacity: [12, 11, 10, 7, 4, 1],
    },
    {
        lvl: 11,
        bonus: 6,
        require: [0, 0, 2, 2, 2, 1],
        capacity: [12, 12, 11, 8, 5, 2],
    },
    {
        lvl: 12,
        bonus: 7,
        require: [0, 0, 1, 3, 3, 1],
        capacity: [12, 12, 12, 9, 6, 3],
    },
    {
        lvl: 13,
        bonus: 7,
        require: [0, 0, 1, 3, 3, 2],
        capacity: [12, 12, 12, 10, 7, 4],
    },
    {
        lvl: 14,
        bonus: 8,
        require: [0, 0, 0, 4, 3, 3],
        capacity: [12, 12, 12, 11, 8, 5],
    },
    {
        lvl: 15,
        bonus: 8,
        require: [0, 0, 0, 5, 4, 3],
        capacity: [12, 12, 12, 12, 9, 6],
    },
    {
        lvl: 16,
        bonus: 9,
        require: [0, 0, 0, 6, 4, 4],
        capacity: [12, 12, 12, 12, 10, 8],
    },
    {
        lvl: 17,
        bonus: 9,
        require: [0, 0, 0, 8, 6, 4],
        capacity: [16, 12, 12, 12, 11, 8],
    },
    {
        lvl: 18,
        bonus: 9,
        require: [0, 0, 0, 10, 6, 5],
        capacity: [16, 16, 12, 12, 12, 8],
    },
    {
        lvl: 19,
        bonus: 10,
        require: [0, 0, 0, 12, 8, 5],
        capacity: [16, 16, 16, 12, 12, 10],
    },
    {
        lvl: 20,
        bonus: 10,
        require: [0, 0, 0, 12, 8, 6],
        capacity: [16, 16, 16, 16, 12, 10],
    },
    {
        lvl: 21,
        bonus: 10,
        require: [0, 0, 0, 14, 10, 6],
        capacity: [16, 16, 16, 16, 14, 12],
    },
    {
        lvl: 22,
        bonus: 10,
        require: [0, 0, 0, 16, 12, 8],
        capacity: [16, 16, 16, 16, 16, 12],
    },
]

export const star_soul = 
[
  { "lvl":  1, "stars": 1, "soul":  1,     "essence": null,  "speed":   0, "atk":  0, "hp":  0, "skill": "A1", "skill_lvl": 1 },
  { "lvl":  2, "stars": 1, "soul": null,   "essence": 11100, "speed":  10, "atk":  4, "hp":  0, "skill": null, "skill_lvl": 0 },
  { "lvl":  3, "stars": 1, "soul": null,   "essence": 13300, "speed":  20, "atk":  4, "hp":  5, "skill": null, "skill_lvl": 0 },
  { "lvl":  4, "stars": 1, "soul": null,   "essence": 15600, "speed":  20, "atk":  4, "hp":  5, "skill": "A1", "skill_lvl": 2 },

  { "lvl":  5, "stars": 2, "soul":  1,     "essence": null,  "speed":  20, "atk":  4, "hp":  5, "skill": "P1", "skill_lvl": 1 },
  { "lvl":  6, "stars": 2, "soul": null,   "essence": 21300, "speed":  30, "atk":  8, "hp":  5, "skill": null, "skill_lvl": 0 },
  { "lvl":  7, "stars": 2, "soul": null,   "essence": 24000, "speed":  40, "atk":  8, "hp": 10, "skill": null, "skill_lvl": 0 },
  { "lvl":  8, "stars": 2, "soul": null,   "essence": 26700, "speed":  40, "atk":  8, "hp": 10, "skill": "P1", "skill_lvl": 2 },

  { "lvl":  9, "stars": 3, "soul":  2,     "essence": null,  "speed":  40, "atk":  8, "hp": 10, "skill": "P2", "skill_lvl": 1, "assist_skill": "1" },
  { "lvl": 10, "stars": 3, "soul": null,   "essence": 28100, "speed":  50, "atk": 12, "hp": 10, "skill": null, "skill_lvl": 0 },
  { "lvl": 11, "stars": 3, "soul": null,   "essence": 30700, "speed":  60, "atk": 12, "hp": 15, "skill": null, "skill_lvl": 0 },
  { "lvl": 12, "stars": 3, "soul": null,   "essence": 33200, "speed":  60, "atk": 12, "hp": 15, "skill": "P2", "skill_lvl": 2 },

  { "lvl": 13, "stars": 4, "soul": 2,      "essence": null,  "speed":  60, "atk": 12, "hp": 15, "skill": "A2", "skill_lvl": 1, "lock": 18 },
  { "lvl": 14, "stars": 4, "soul": null,   "essence": 34800, "speed":  70, "atk": 16, "hp": 15, "skill": null, "skill_lvl": 0 },
  { "lvl": 15, "stars": 4, "soul": null,   "essence": 37300, "speed":  80, "atk": 16, "hp": 20, "skill": null, "skill_lvl": 0 },
  { "lvl": 16, "stars": 4, "soul": null,   "essence": 39800, "speed":  80, "atk": 16, "hp": 20, "skill": "A2", "skill_lvl": 2 },

  { "lvl": 17, "stars": 5, "soul": 3,      "essence": null,  "speed":  80, "atk": 16, "hp": 20, "skill": "P3", "skill_lvl": 1, "lock": 24, "assist_skill": "2" },
  { "lvl": 18, "stars": 5, "soul": null,   "essence": 41600, "speed":  90, "atk": 20, "hp": 20, "skill": null, "skill_lvl": 0 },
  { "lvl": 19, "stars": 5, "soul": null,   "essence": 44000, "speed": 100, "atk": 20, "hp": 25, "skill": null, "skill_lvl": 0 },
  { "lvl": 20, "stars": 5, "soul": null,   "essence": 46400, "speed": 100, "atk": 20, "hp": 25, "skill": "P3", "skill_lvl": 2 },

  { "lvl": 21, "stars": 6, "soul": 3,      "essence": null,  "speed": 100, "atk": 20, "hp": 25, "skill": "P4", "skill_lvl": 1, "lock": 30 },
  { "lvl": 22, "stars": 6, "soul": null,   "essence": 48300, "speed": 110, "atk": 24, "hp": 25, "skill": null, "skill_lvl": 0 },
  { "lvl": 23, "stars": 6, "soul": null,   "essence": 50700, "speed": 120, "atk": 24, "hp": 30, "skill": null, "skill_lvl": 0 },
  { "lvl": 24, "stars": 6, "soul": null,   "essence": 53100, "speed": 120, "atk": 24, "hp": 30, "skill": "P4", "skill_lvl": 2 },

  { "lvl": 25, "stars": 7, "soul": 1,      "essence": null,  "speed": 120, "atk": 24, "hp": 30, "skill": "P5", "skill_lvl": 1, "soul2": 1,      "essence2": null, "lock": 36 },
  { "lvl": 26, "stars": 7, "soul": null,   "essence": 24800, "speed": 130, "atk": 27, "hp": 30, "skill": null, "skill_lvl": 0, "soul2": null,   "essence2": 24800 },
  { "lvl": 27, "stars": 7, "soul": null,   "essence": 25800, "speed": 140, "atk": 27, "hp": 34, "skill": null, "skill_lvl": 0, "soul2": null,   "essence2": 25800 },
  { "lvl": 28, "stars": 7, "soul": null,   "essence": 26900, "speed": 140, "atk": 27, "hp": 34, "skill": "P5", "skill_lvl": 2, "soul2": null,   "essence2": 26900 },

  { "lvl": 29, "stars": 8, "soul": 1,      "essence": null,  "speed": 140, "atk": 27, "hp": 34, "skill": "P6", "skill_lvl": 1, "soul2": 1,      "essence2": null, "lock": 42 },
  { "lvl": 30, "stars": 8, "soul": null,   "essence": 27800, "speed": 150, "atk": 30, "hp": 34, "skill": null, "skill_lvl": 0, "soul2": null,   "essence2": 27800 },
  { "lvl": 31, "stars": 8, "soul": null,   "essence": 28800, "speed": 160, "atk": 30, "hp": 38, "skill": null, "skill_lvl": 0, "soul2": null,   "essence2": 28800 },
  { "lvl": 32, "stars": 8, "soul": null,   "essence": 29900, "speed": 160, "atk": 30, "hp": 38, "skill": "P6", "skill_lvl": 2, "soul2": null,   "essence2": 29900 },
]

export const destiny_trail = 
[
  { "stars": 1, "sub_lvl":  1, "lvl":  1, "material":       0 },
  { "stars": 1, "sub_lvl":  2, "lvl":  2, "material": 1624600 },
  { "stars": 1, "sub_lvl":  3, "lvl":  3, "material": 1772300 },
  { "stars": 1, "sub_lvl":  4, "lvl":  4, "material": 1920000 },
  { "stars": 1, "sub_lvl":  5, "lvl":  5, "material": 2067700 },
  { "stars": 1, "sub_lvl":  6, "lvl":  6, "material": 2215400 },

  { "stars": 2, "sub_lvl":  1, "lvl":  7, "material": 2490800, "lock": 5 },
  { "stars": 2, "sub_lvl":  2, "lvl":  8, "material": 2646500 },
  { "stars": 2, "sub_lvl":  3, "lvl":  9, "material": 2802200 },
  { "stars": 2, "sub_lvl":  4, "lvl": 10, "material": 2957800 },
  { "stars": 2, "sub_lvl":  5, "lvl": 11, "material": 3113500 },
  { "stars": 2, "sub_lvl":  6, "lvl": 12, "material": 3269200 },

  { "stars": 3, "sub_lvl":  1, "lvl": 13, "material": 3304500, "lock": 9 },
  { "stars": 3, "sub_lvl":  2, "lvl": 14, "material": 3454700 },
  { "stars": 3, "sub_lvl":  3, "lvl": 15, "material": 3604900 },
  { "stars": 3, "sub_lvl":  4, "lvl": 16, "material": 3755100 },
  { "stars": 3, "sub_lvl":  5, "lvl": 17, "material": 3905300 },
  { "stars": 3, "sub_lvl":  6, "lvl": 18, "material": 4055500 },

  { "stars": 4, "sub_lvl":  1, "lvl": 19, "material": 4868800, "lock": 13 },
  { "stars": 4, "sub_lvl":  2, "lvl": 20, "material": 5093800 },
  { "stars": 4, "sub_lvl":  3, "lvl": 21, "material": 5318800 },
  { "stars": 4, "sub_lvl":  4, "lvl": 22, "material": 5543800 },
  { "stars": 4, "sub_lvl":  5, "lvl": 23, "material": 5768800 },
  { "stars": 4, "sub_lvl":  6, "lvl": 24, "material": 5993800 },

  { "stars": 5, "sub_lvl":  1, "lvl": 25, "material": 6143100, "lock": 17 },
  { "stars": 5, "sub_lvl":  2, "lvl": 26, "material": 6365900 },
  { "stars": 5, "sub_lvl":  3, "lvl": 27, "material": 6588600 },
  { "stars": 5, "sub_lvl":  4, "lvl": 28, "material": 6811400 },
  { "stars": 5, "sub_lvl":  5, "lvl": 29, "material": 7034200 },
  { "stars": 5, "sub_lvl":  6, "lvl": 30, "material": 7257000 },

  { "stars": 6, "sub_lvl":  1, "lvl": 31, "material": 7415800, "lock": 21 },
  { "stars": 6, "sub_lvl":  2, "lvl": 32, "material": 7637000 },
  { "stars": 6, "sub_lvl":  3, "lvl": 33, "material": 7858200 },
  { "stars": 6, "sub_lvl":  4, "lvl": 34, "material": 8079300 },
  { "stars": 6, "sub_lvl":  5, "lvl": 35, "material": 8300500 },
  { "stars": 6, "sub_lvl":  6, "lvl": 36, "material": 8521700 },

  { "stars": 7, "sub_lvl":  1, "lvl": 37, "material": 3696200, "material2": 3696200 },
  { "stars": 7, "sub_lvl":  2, "lvl": 38, "material": 3760100, "material2": 3760100 },
  { "stars": 7, "sub_lvl":  3, "lvl": 39, "material": 3824000, "material2": 3824000 },
  { "stars": 7, "sub_lvl":  4, "lvl": 40, "material": 3888000, "material2": 3888000 },
  { "stars": 7, "sub_lvl":  5, "lvl": 41, "material": 3951900, "material2": 3951900 },
  { "stars": 7, "sub_lvl":  6, "lvl": 42, "material": 4015800, "material2": 4015800 },

  { "stars": 8, "sub_lvl":  1, "lvl": 43, "material": 4057300, "material2": 4057300 },
  { "stars": 8, "sub_lvl":  2, "lvl": 44, "material": 4120800, "material2": 4120800 },
  { "stars": 8, "sub_lvl":  3, "lvl": 45, "material": 4184300, "material2": 4184300 },
  { "stars": 8, "sub_lvl":  4, "lvl": 46, "material": 4247700, "material2": 4247700 },
  { "stars": 8, "sub_lvl":  5, "lvl": 47, "material": 4311200, "material2": 4311200 },
  { "stars": 8, "sub_lvl":  6, "lvl": 48, "material": 4374700, "material2": 4374700 },
]

export const star_souls = {
    Nova : {
        name: "Sacred Flame",
        other: null,
        atk: 24000000,
        hp: 5184000000,
        atk2: 0,
        hp2: 0,
    },
    Pupil : {
        name: "Ethernal Darkness",
        other: "Specter",
        atk: 30000000,
        hp: 4320000000,
        atk2: 42000000,
        hp2: 6048000000,
    },
    Specter : {
        name: "Inquiring Mind",
        other: "Bloom",
        atk: 27000000,
        hp: 4752000000,
        atk2: 37800000,
        hp2: 6652800000,
    },
    Plume : {
        name: "Time Manipulation",
        other: "Nova",
        atk: 21000000,
        hp: 5400000000,
        atk2: 29400000,
        hp2: 7560000000,
    },
    Bloom : {
        name: "Genesis Radiance",
        other: null,
        atk: 22500000,
        hp: 5184000000,
        atk2: 0,
        hp2: 0,
    },
    Butterfly : {
        name: "Cosmic Rhythm",
        other: null,
        atk: 22500000,
        hp: 5400000000,
        atk2: 0,
        hp2: 0,
    },
    Netherfish : {
        name: "Convergence",
        other: null,
        atk: 22500000,
        hp: 5400000000,
        atk2: 0,
        hp2: 0,
    },
}
